import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../dist/asyncToGenerator-0859ab5c.esm.js';
import { useReducer } from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
	* A Ract hook for storing the xhr/api async states (data, loading, completed & error)
	*
	* Todo:
	*  response data can be stored in browser storage (for short time peroid) for caching purpose & avoiding the
	*  same api call from different location.
	*/

var initialState = {
  data: null,
  error: false,
  loading: false,
  completed: false
};
function reducer(state, action) {
  switch (action.type) {
    case 'error':
      return _extends({}, state, {
        error: action.error,
        completed: true,
        loading: false
      });
    case 'data':
      return _extends({}, state, {
        data: action.data,
        completed: true,
        loading: false,
        error: false
      });
    case 'loading':
      return _extends({}, state, {
        loading: action.loading,
        completed: false
      });
    default:
      return _extends({}, state);
  }
}

// returning api state and trigger function
var useApiCall = function useApiCall(xhrFunction, hookOpts) {
  if (hookOpts === void 0) {
    hookOpts = {};
  }
  var _useReducer = useReducer(reducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var makeApiCall = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(callOptions) {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (callOptions === void 0) {
              callOptions = {};
            }
            _context.prev = 1;
            dispatch({
              type: 'loading',
              loading: true
            });
            _context.next = 5;
            return xhrFunction(_extends({}, hookOpts, callOptions));
          case 5:
            res = _context.sent;
            dispatch({
              type: 'data',
              data: res
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            dispatch({
              type: 'error',
              error: _context.t0
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function makeApiCall(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var start = function start(o) {
    return makeApiCall(o);
  };
  return [state, start];
};

export { useApiCall };
